import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import NProgress from '@/utils/nprogress' // progress bar
import { stringifyQuery, parseQuery } from '@/utils/query'

Vue.use(Router)

// 基本路由
export const baseRoutes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录' }
  },
  {
    path: '/dashboard',
    // component: () => import('@/views/dashboard/index'),
    component: Layout,
    hidden: true,
    redirect: '/dashboard/home',
    children: [
      {
        path: 'home',
        meta: { title: '首页' },
        component: () => import('@/views/dashboard/tips')
      }
    ]
  },
  {
    path: '/account',
    component: () => import('@/views/account/index')
  },
  {
    path: '/snapshot',
    component: () => import('@/views/instruct/snapshot')
  },
  {
    path: '*',
    component: Layout,
    redirect: '/404',
    hidden: true,
    children: [
      {
        path: '404',
        name: 'error',
        component: () => import('@/views/404/index'),
        meta: { title: '404', icon: 'dashboard', affix: false }
      }
    ]
  }
]

const router = new Router({
  base: process.env.VUE_APP_BASE_PATH,
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: baseRoutes,
  stringifyQuery,
  parseQuery
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach((to, from, next) => {
  NProgress.done()
})

export default router
